var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.772,
    height: 19.772,
    viewBox: "0 0 19.772 19.772",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-log-out",
    "data-name": "Icon feather-log-out",
    transform: "translate(-3 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M10.091,21.272H6.364A1.864,1.864,0,0,1,4.5,19.408V6.364A1.864,1.864,0,0,1,6.364,4.5h3.727",
    fill: "none",
    stroke: "#d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M24,19.818l4.659-4.659L24,10.5",
    transform: "translate(-7.387 -2.273)",
    fill: "none",
    stroke: "#d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M24.681,18H13.5",
    transform: "translate(-3.409 -5.114)",
    fill: "none",
    stroke: "#d00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignOut);
export default __webpack_public_path__ + "static/media/icon-sign-out.a9b14e53e5f902a6e55dd17ae1f86d4b.svg";
export { ForwardRef as ReactComponent };